export const Types = {
  SAVE_TIME_WORK : 'SAVE_TIME_WORK',
}
